import { CSSProperties } from 'react';
import BgStickyGradient from '../../../../../ui/flow-components/bg-sticky-gradient';

const Shimmer = ({ className = '', style }: { className?: string; style?: CSSProperties }) => (
  <div
    className={`relative overflow-hidden bg-white/10 rounded ${className}`}
    style={{
      backgroundImage: 'linear-gradient(90deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.14) 50%, rgba(255,255,255,0.04) 100%)',
      backgroundSize: '200% 100%',
      animation: 'skeletonShimmer 1.8s ease-in-out infinite',
      ...style
    }}
  />
);

const SkeletonCard = () => (
  <div className="relative w-full lg:w-1/2 flex flex-col rounded-2xl p-[1.5px]">
    <div
      className="pointer-events-none absolute inset-0 rounded-2xl p-[1.5px] bg-gradient-to-b from-white/10 to-white/5 opacity-60"
      style={{
        WebkitMask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        WebkitMaskComposite: 'xor',
        maskComposite: 'exclude'
      }}
    />
    <div className="absolute top-6 right-6 z-20">
      <Shimmer className="rounded-full h-6 w-28" />
    </div>
    <div className="relative rounded-2xl shadow-[inset_0_-16px_36px_rgba(255,255,255,0.05)] bg-white/5 border-white/10 border-[1.5px]">
      <div className="flex flex-col gap-6 p-[32px] rounded-2xl min-h-[360px]">
        {/* Title + Price */}
        <div className="flex flex-col gap-2 items-start">
          <Shimmer className="h-5 w-28 mb-1" />
          <div className="flex items-baseline gap-2">
            <Shimmer className="h-12 w-36 rounded-lg" />
            <Shimmer className="h-4 w-24 ml-2" />
          </div>
        </div>

        {/* Description */}
        <div className="flex flex-col gap-2 -mt-1">
          <Shimmer className="h-4 w-full" />
          <Shimmer className="h-4 w-3/4" />
        </div>

        {/* Features heading */}
        <Shimmer className="h-4 w-40 mt-2" />

        {/* Features */}
        <div className="flex flex-col gap-4">
          {[...Array(7)].map((_, i) => (
            <div key={i} className="flex items-center gap-2 px-2 py-[2px]">
              <Shimmer className="h-5 w-5 rounded-full shrink-0" />
              <Shimmer className="h-4 rounded" style={{ width: `${55 + ((i * 7) % 35)}%` }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

/*
const SkeletonFrequencySwitch = () => (
  <div className="flex items-center justify-center mb-8 animate-pulse">
    <div className="bg-[#0C1819] rounded-[12px] py-[6px] px-[22px] flex flex-col md:flex-row gap-2 border-[1.5px] border-[#192425] w-fit mx-auto shadow-[inset_0_-16px_36px_rgba(255,255,255,0.1)]">
      {[0, 1, 2].map((i) => (
        <div key={i} className="px-[14px] py-[10px] rounded-[8px] border-[1.5px] border-white/5">
          <div className="h-5 bg-white/20 rounded w-24"></div>
        </div>
      ))}
    </div>
  </div>
);
*/

const SkeletonPaymentForm = () => (
  <div className="bg-white rounded-xl p-6 lg:p-8 animate-pulse w-full">
    <div className="space-y-6">
      {/* Form title */}
      <div className="h-6 bg-black/10 rounded w-32"></div>

      {/* Form fields */}
      <div className="space-y-4">
        <div className="h-12 bg-black/10 rounded-lg w-full"></div>
        <div className="h-12 bg-black/10 rounded-lg w-full"></div>
        <div className="h-12 bg-black/10 rounded-lg w-full"></div>
      </div>

      {/* Buttons */}
      <div className="flex gap-3 flex-col">
        <div className="h-12 bg-black/10 rounded-lg w-full"></div>
        <div className="h-12 border border-black/10 rounded-lg w-full"></div>
      </div>
    </div>
  </div>
);

export const CheckoutSkeleton = () => {
  return (
    <div className="min-h-screen bg-black relative w-screen">
      <BgStickyGradient />

      <div className="flex flex-col lg:flex-row w-full min-h-screen relative z-10">
        {/* Plans Section */}
        <div className="w-full lg:w-2/3 flex flex-col justify-center items-center lg:p-0">
          <div className="p-4 lg:p-20 flex flex-col gap-8 w-full max-w-5xl">
            {/* Billing Frequency Switch Skeleton */}

            {/* Package Cards Skeleton */}
            <div className="w-full flex flex-row">
              <div className="w-full flex flex-col lg:flex-row gap-6">
                <SkeletonCard />
                <SkeletonCard />
              </div>
            </div>
          </div>
        </div>

        {/* Form Section Skeleton */}
        <div className="w-full lg:w-1/3 p-4 lg:pr-16 pr-4 flex items-center">
          <SkeletonPaymentForm />
        </div>
      </div>
    </div>
  );
};
